<div bsModal #equipmentManipulate="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <form (ngSubmit)="save()" #equipmentManipulateForm="ngForm">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" (click)="close()" aria-hidden="true" data-bind="click: $root.cancelAddEquipment">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">{{edit ? 'Edit Equipment &bull; ' + equipment.Serial : 'Create Equipment'}}</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback">
                                <label class="control-group input-group-addon" for="newSerialNumber">Serial Number</label>
                                <input #serialNumberControl="ngModel" id="newSerialNumber" name="NewEquipmentSerial" type="text" class="form-control" required placeholder="Serial Number" [(ngModel)]="equipment.Serial" [ngClass]="{'has-error' : !serialNumberControl.valid }" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <label class="input-group-addon">Model</label>
                                <select name="selectedModel" class="form-control" required [(ngModel)]="equipment.ModelId" #modelControl="ngModel" [ngClass]="{'has-error' : !modelControl.valid }">
                                    <option *ngFor="let model of models" [value]="model.Id" [selected]="equipment.ModelId == model.Id">{{ model.Name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <label class="input-group-addon">Powered By</label>
                                <select name="selectedPoweredBy" class="form-control" required [(ngModel)]="equipment.PoweredById" #poweredByControl="ngModel" [ngClass]="{'has-error' : !poweredByControl.valid }">
                                    <option *ngFor="let poweredby of poweredBys" [value]="poweredby.Id" [selected]="equipment.PoweredById == poweredby.Id">{{ poweredby.Name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="edit">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback">
                                <label class="control-group input-group-addon">Status</label>
                                <div class="btn-group btn-group-justified">
                                    <label class="btn" [class.btn-info]="equipment.Active" [class.btn-warning]="!equipment.Active" (click)="equipment.Active = !equipment.Active">
                                        <span>{{ equipment.Active ? 'Active' : 'Inactive' }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" *ngIf="!edit" class="pull-left btn btn-default" (click)="save(true)" [disabled]="!equipmentManipulateForm.form.valid">Create and Add Another</button>
                    <button type="button" class="btn btn-default" (click)="close()">Close</button>
                    <button type="submit" class="btn btn-primary" [disabled]="!equipmentManipulateForm.form.valid">{{ edit ? 'Save' : 'Create' }}</button>
                </div>
            </form>
        </div>
    </div>
</div>